//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailTopPart from "./components/DetailTopPart";
import OrderSettlement from "./components/OrderSettlement";
export default {
  name: "FarmingOrderSettleDetail",
  components: {
    DetailTopPart,
    OrderSettlement,
  },
  data() {
    return {
      id: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
  },
};
